import React from "react";
import PropTypes from "prop-types";

import { Colours } from "@learningblocks/shared-components";

export default function CheckBox(props) {
  return (
    <div style={{ display: "flex", margin: "4px 0" }}>
      <div
        style={{
          ...{
            position: "relative",
            display: "inline-block",
            width: "40px",
            height: "20px",
            marginRight: "4px",
            marginTop: "9px",
          },
          ...props.style,
        }}
      >
        <input
          id={props.value}
          type="checkbox"
          className="checkBox"
          name={props.value}
          value={props.value}
          checked={props.checked}
          onChange={props.onChange}
          style={{
            opacity: 0,
            width: "100%",
            height: "100%",
            margin: 0,
            cursor: "pointer",
          }}
        />
        <span
          class="toggle"
          style={{
            borderRadius: "17px",
            position: "absolute",
            cursor: "pointer",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            backgroundColor: props.checked ? Colours.navy1 : Colours.navy5,
            transition: ".4s",
            pointerEvents: "none",
          }}
        ></span>
      </div>
      <label
        style={{ display: "inline-block", cursor: "pointer", padding: "9px 0" }}
        for={props.value}
      >
        {props.title}
      </label>
      {props.legend ? (
        <img
          src={props.legend}
          alt="Total DNA line indicator"
          style={{ marginLeft: "auto" }}
        />
      ) : null}
    </div>
  );
}
CheckBox.PropTypes = {
  value: PropTypes.string,
  onChange: PropTypes.function,
  checked: PropTypes.boolean,
  title: PropTypes.string,
  legend: PropTypes.object,
  style: PropTypes.object,
};
